import React from "react";
import { Typography, Grid2 as Grid } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Cause } from "../../../shared/types";

export interface ItemProps {
  cause: Cause;
  handleSelect: () => void;
}

export const Item = ({ cause, handleSelect }: ItemProps): React.JSX.Element => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"));
  const tablet = useMediaQuery(theme.breakpoints.down("lg"));
  let size: number = 12;
  switch (cause.size) {
    case "small":
      size = mobile ? 12 : tablet ? 4 : 3;
      break;
    case "medium":
      size = mobile ? 12 : 6;
      break;
    case "large":
      size = mobile ? 12 : 12;
      break;
  }

  return (
    <Grid
      container
      size={size}
      onClick={() => {
        handleSelect();
      }}
      sx={{
        "& img": { boxShadow: 3 },
        "& h5": { color: "#272643" },
        "& p": { borderLeft: "3px solid #272643" },
        "&:hover": {
          "& img": { boxShadow: 8 },
          "& h5": { color: "rgb(44, 105, 141)" },
          "& p": { borderLeft: "3px solid rgb(44, 105, 141)" },
        },
        paddingBottom: "24px",
        cursor: "pointer",
      }}
    >
      <Grid size={{ xs: 12 }}>
        <img
          src={cause.thumbnail}
          style={{ borderRadius: "24px", width: "100%", marginBottom: "6px" }}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Typography
          variant="h5"
          style={{ fontWeight: "bold", marginTop: "16px" }}
        >
          {cause.name}
        </Typography>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Typography
          variant="body1"
          component="div"
          style={{ marginTop: "12px" }}
        >
          {cause.summary}
        </Typography>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Typography
          variant="body1"
          style={{
            paddingLeft: "6px",
            marginTop: "12px",
          }}
        >{`${cause.eins.length} ${
          cause.eins.length > 1 ? "Charities" : "Charity"
        }`}</Typography>
      </Grid>
    </Grid>
  );
};
